import React from "react";
import Link from "next/link";
import FadeInAnimation from "../Common/FadeInAnimation";
import { useTranslations } from '../../locales/useTranslations';
import { BiLogoVisualStudio, BiLogoChrome, BiLogoWordpress, BiBuildings, BiChevronRight } from "react-icons/bi";

const AppDevelopmentWeitereServices = () => {
  const { t } = useTranslations();

  return (
    <>
      <div className="services-area ptb-70">
        <div className="container">
          <div className="section-title text-left">
            <span className="sub-title">{t('appDevelopment_otherServices_subtitle')}</span>
            <h2>{t('appDevelopment_otherServices_title')}</h2>
          </div>

          <FadeInAnimation direction="up" delay={100}>
            <div className="container">
              <div className="row">

                <div className="col-sm-6">
                  <Link href="/web-development" className="read-more">
                    <div className="features-box">
                      <div className="icon">
                        <BiLogoChrome />
                      </div>
                      <h3>{t('appDevelopment_otherServices_webDevelopment_title')}</h3>
                      <p>
                        {t('appDevelopment_otherServices_webDevelopment_description')}
                      </p>
                      <span className="features-box-action">{t('appDevelopment_otherServices_webDevelopment_readMore')}
                      <BiChevronRight />
                      </span>
                      <div className="back-icon">
                        <BiLogoChrome />
                      </div>
                    </div>
                  </Link>
                </div>

                <div className="col-sm-6">
                  <Link href="/software-development" className="read-more">
                    <div className="features-box">
                      <div className="icon">
                        <BiLogoVisualStudio />
                      </div>
                      <h3>{t('appDevelopment_otherServices_softwareDevelopment_title')}</h3>
                      <p>
                        {t('appDevelopment_otherServices_softwareDevelopment_description')}
                      </p>

                      <span className="features-box-action">{t('appDevelopment_otherServices_softwareDevelopment_readMore')}
                      <BiChevronRight />
                      </span>
                      <div className="back-icon">
                        <BiLogoVisualStudio />
                      </div>
                    </div>
                  </Link>
                </div>

                <div className="col-sm-6">
                  <Link href="/web-development/wordpress-entwicklung/" className="read-more">
                    <div className="features-box">
                      <div className="icon">
                        <BiLogoWordpress />
                      </div>
                      <h3>{t('appDevelopment_otherServices_wordpressDevelopment_title')}</h3>
                      <p dangerouslySetInnerHTML={{ __html: t('appDevelopment_otherServices_wordpressDevelopment_description') }} />
                      <span className="features-box-action">{t('appDevelopment_otherServices_wordpressDevelopment_readMore')}
                      <BiChevronRight />
                      </span>
                      <div className="back-icon">
                        <BiLogoWordpress />
                      </div>
                    </div>
                  </Link>
                </div>

                <div className="col-sm-6">
                  <Link href="/it-consulting" className="read-more">
                    <div className="features-box">
                      <div className="icon">
                        <BiBuildings />
                      </div>
                      <h3>{t('appDevelopment_otherServices_itConsulting_title')}</h3>
                      <p dangerouslySetInnerHTML={{ __html: t('appDevelopment_otherServices_itConsulting_description') }} />
                      <span className="features-box-action">{t('appDevelopment_otherServices_itConsulting_readMore')}
                      <BiChevronRight />
                      </span>
                      <div className="back-icon">
                        <BiBuildings />
                      </div>
                    </div>
                  </Link>
                </div>

              </div>
            </div>
          </FadeInAnimation>
        </div>
      </div>

    </>
  );
};

export default AppDevelopmentWeitereServices;
